import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import * as Icon from "react-feather";
import {
  getRoles,
  getUsers,
  saveUser,
  removeUser,
} from "../../services/userService";
import CustomLoader from "../common/Loader";
import Tooltip from "@material-ui/core/Tooltip";
import {
  addInstitutionUserMappings,
  deleteInstitutionUserMappings,
  getInstitutions
} from "../../services/InstitutionService";
import Select from "react-select";
import { logActivity } from "../../services/utilService";

class Users extends Component {
  Roles = [];
  state = {
    Users: [],
    Institutions: [],
    userInstitutions: {},
    new_user: {
      User_ID: 0,
      First_Name: "",
      Last_Name: "",
      Username: "",
      Email: "",
      Role_List: [],
      Institution_List: []
    },
    show: false,
    loading: false,
    edit_mode: false,
    edit_idx: 0,
    user_copy: {},
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const { data: roles } = await getRoles();
    this.Roles = roles;

    const { data: Users } = await getUsers();
    const { data: InstitutionsRaw} = await getInstitutions();
    const userInstitutions = {}
    Users.forEach((user, idx) => {
      let newArray = [];
      if(user["Institution_List"] !== '') {
        let institution_array = user["Institution_List"].split(',');
        institution_array.forEach(institution_id => {
          let label = InstitutionsRaw.filter(institution => parseInt(institution['Institution_ID']) === parseInt(institution_id))[0]
          //console.log(institution_id, InstitutionsRaw, label)
          newArray.push({ value: parseInt(institution_id), label: label === undefined ? '' : label['Institution_Name'] });
        });
      }
      Users[idx]["Institution_List"] = newArray;
      userInstitutions[idx] = newArray

      let roleArray = []
      if (user['Role_List'] !== '') {
        user['Role_List'].split(',').forEach(role_id => {
          let label = this.Roles.filter(role => parseInt(role['Role_ID']) === parseInt(role_id))[0]
          roleArray.push({ value: parseInt(role_id), label: label === undefined ? '' : label['Role_Name']})
        })
      }
      Users[idx]['Role_List'] = roleArray
    })
    let Institutions = [];
    InstitutionsRaw.forEach(institution => {
      Institutions.push({value: parseInt(institution["Institution_ID"]), label: institution["Institution_Name"]})
    })

    let Roles = []
    this.Roles.forEach(role => {
      Roles.push({ value: parseInt(role['Role_ID']), label: role['Role_Name']})
    })
    this.setState({ Users, Institutions, userInstitutions, Roles});

    this.setState({ loading: false });
  }

  updateUserInstitutions = async (userID, oldInstitutionList, newInstitutionList) => {
    let addedInstitutions = [];
    let removedInstitutions = [];
    oldInstitutionList.forEach(institution => {
      let oldDeleted = true;
      newInstitutionList.forEach(newInstitution => {
        if(institution['value'] === newInstitution['value']) {
          oldDeleted = false;
        }
      })
      if(oldDeleted) {
        removedInstitutions.push(institution['value'])
      }
    })
    newInstitutionList.forEach(newInstitution => {
      let isNew = true;
      oldInstitutionList.forEach(institution => {
        if(institution['value'] === newInstitution['value']) {
          isNew = false
        }
      });
      if(isNew) {
        addedInstitutions.push(newInstitution['value'])
      }
    })
    for (const institutionID of removedInstitutions) {
      await deleteInstitutionUserMappings({Institution_ID: institutionID, User_ID: parseInt(userID)})
    }
    for (const institutionID of addedInstitutions) {
      await addInstitutionUserMappings({Institution_ID: institutionID, User_ID: parseInt(userID)})
    }
  }

  handleSave = async (idx) => {
    const { data } = await saveUser(this.state.Users[idx]);
    if (typeof data === "string" && data.includes("Error")) {
      toaster('error', data);
      logActivity('/users','USER_SAVE_FAILED');
    } else {
      let Users = [...this.state.Users];
      // Save user does not return Institution List
      let userInstitutionsSave = this.state.Users[idx]['Institution_List']
      Users[idx] = data;
      Users[idx]['Institution_List'] = userInstitutionsSave;
      Users[idx]['Role_List'] = this.state.Users[idx]['Role_List']
      this.setState({ Users });

      let {userInstitutions} = this.state;
      await this.updateUserInstitutions(Users[idx]['User_ID'], userInstitutions[idx], Users[idx]['Institution_List'])
      userInstitutions[idx] = Users[idx]['Institution_List'];
      this.setState({userInstitutions})

      toaster('success', 'User saved.');
      logActivity('/users','USER_SAVE_SUCCESS');
      this.disableEdit();
    }
  };

  handleSaveNew = async () => {
    let {new_user} = this.state;
    const { data } = await saveUser(new_user);
    if (typeof data === "string" && data.includes("Error")) {
      toaster('error', data);
      logActivity('/users','USER_CREATE_FAILED');
    } else {
      data['Institution_List'] = new_user['Institution_List']
      data['Role_List'] = new_user['Role_List']
      const Users = [...this.state.Users, data];
      this.setState({ Users });

      let {userInstitutions} = this.state;
      await this.updateUserInstitutions(Users[Users.length - 1]['User_ID'], [], data['Institution_List'])
      userInstitutions[Users.length - 1] = data['Institution_List'];
      this.setState({userInstitutions})

      new_user = {
        User_ID: 0,
        First_Name: "",
        Last_Name: "",
        Username: "",
        Email: "",
        Role_List: [],
        Institution_List: []
      };
      this.setState({ new_user });
      toaster('success', 'User saved.');
      logActivity('/users','USER_CREATE_SUCCESS');
      this.handleClose();
    }
  };

  handleShow = () => {
    this.setState({ show: true });
  };

  handleClose = () => {
    const new_user = {
      User_ID: 0,
      First_Name: "",
      Last_Name: "",
      Username: "",
      Email: "",
      Role_List: [],
      Institution_List: []
    };
    this.setState({ show: false, new_user });
  };

  enableEdit = (idx) => {
    // const user_copy = this.state.Users.map((user) => ({ ...user }));
    const user_copy = { ...this.state.Users[idx] };
    this.setState({ user_copy });
    this.setState({ edit_idx: idx });
    this.setState({ edit_mode: true });
  };

  disableEdit = () => {
    this.setState({ edit_idx: -1 });
    this.setState({ edit_mode: false });
  };

  restoreUser = () => {
    // const Users = this.state.Users_copy.map((user) => ({ ...user }));
    let Users = [...this.state.Users];
    Users[this.state.edit_idx] = { ...this.state.user_copy };
    this.setState({ Users });
    this.setState({ user_copy: {} });
    this.disableEdit();
  };

  handleUserEdit = (name, value, index, isSelect = false) => {
    const Users = [...this.state.Users];
    if (isSelect) {
      value = parseInt(value);
    }
    Users[index][name] = value;
    this.setState({ Users });
  };

  handleNewUserChange = (name, value, isSelect = false) => {
    const new_user = { ...this.state.new_user };
    if (isSelect) {
      value = parseInt(value);
    }
    new_user[name] = value;
    this.setState({ new_user });
  };

  handleRemove = async (UID) => {
    const { data } = await removeUser(UID);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/users','USER_DELETE_FAILED');
    } else {
      toaster('success', data);
      logActivity('/users','USER_DELETE_SUCCESS');
      const Users = this.state.Users.filter((user) => user.User_ID !== UID);
      this.setState({ Users });
    }
  };

  changeInstitutionValue = (userID, institutionValue) => {
    let {Users} = this.state;
    if(userID >= 0) {
      Users[userID]['Institution_List'] = institutionValue == null ? [] : institutionValue;
      this.setState({Users})
    } else {
      const new_user = { ...this.state.new_user };
      new_user['Institution_List'] = institutionValue == null ? [] : institutionValue;
      this.setState({new_user})
    }
  }

  changeRoleValue = (userID, roleValue) => {
    // console.log(Array.isArray(roleValue))
    let {Users} = this.state;
    if(userID >= 0) {
      Users[userID]['Role_List'] = roleValue == null ? [] : [roleValue];
      this.setState({Users})
    } else {
      const new_user = { ...this.state.new_user };
      new_user['Role_List'] = roleValue == null ? [] : [roleValue];
      this.setState({new_user})
    }
  }

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }
    let { Users, new_user, Institutions, Roles } = this.state;

    return (
      <React.Fragment>
        <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
          <div className="container">
            <div className="page-header-content pt-4">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto mt-4">
                  <h1 className="page-header-title">
                    <div className="page-header-icon">
                      <Icon.Users />
                    </div>
                    Users
                  </h1>
                  <div className="page-header-subtitle">
                    MQUARK User management application wide.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="container mt-n10">
          <div className="card card-header-actions">
            <div className="card-body">
              <div className="float-right">
                <button
                  className="btn btn-pink btn-icon mr-2"
                  onClick={this.handleShow}
                >
                  <Icon.UserPlus />
                </button>
                <Modal show={this.state.show} onHide={this.handleClose}>
                  <Modal.Header closeButton>New List</Modal.Header>
                  <Modal.Body>
                    <form>
                      <div className="form-group">
                        <label htmlFor="FirstName">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="FirstName"
                          name="First_Name"
                          value={new_user.First_Name}
                          onChange={(e) =>
                            this.handleNewUserChange(
                              "First_Name",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="LastName">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="LastName"
                          name="Last_Name"
                          value={new_user.Last_Name}
                          onChange={(e) =>
                            this.handleNewUserChange(
                              "Last_Name",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="Username">Username</label>
                        <input
                          type="text"
                          className="form-control"
                          id="Username"
                          name="Username"
                          value={new_user.Username}
                          onChange={(e) =>
                            this.handleNewUserChange("Username", e.target.value)
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          id="email"
                          name="Email"
                          value={new_user.Email}
                          onChange={(e) =>
                            this.handleNewUserChange("Email", e.target.value)
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="selectRole">Role</label>
                        <Select
                            // isMulti
                            options={Roles}
                            name='Roles'
                            onChange={this.changeRoleValue.bind(null, -1)}
                            placeholder='No Roles Selected'
                            value={new_user["Role_List"][0]}/>
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">Institutions</label>
                        <Select
                            isMulti
                            options={Institutions}
                            name='Institutions'
                            onChange={this.changeInstitutionValue.bind(null, -1)}
                            placeholder='No Institutions Selected'
                            value={new_user["Institution_List"]}/>
                      </div>
                    </form>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btn-primary"
                      onClick={this.handleSaveNew}
                    >
                      Save
                    </button>
                  </Modal.Footer>
                </Modal>
              </div>
              <table className="table table-hover table-borderless table-sm" style={{tableLayout:'fixed'}}>
                <thead className="border-bottom">
                  <tr>
                    <th>User ID</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th style={{width: '18rem'}}>Institutions</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {Users.map((user, idx) => {
                    if (this.state.edit_mode && idx === this.state.edit_idx) {
                      return (
                        <tr key={user.User_ID}>
                          <td>{user.User_ID}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={user.First_Name}
                              onChange={(e) =>
                                this.handleUserEdit(
                                  "First_Name",
                                  e.target.value,
                                  idx
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={user.Last_Name}
                              onChange={(e) =>
                                this.handleUserEdit(
                                  "Last_Name",
                                  e.target.value,
                                  idx
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={user.Username}
                              onChange={(e) =>
                                this.handleUserEdit(
                                  "Username",
                                  e.target.value,
                                  idx
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={user.Email}
                              onChange={(e) =>
                                this.handleUserEdit(
                                  "Email",
                                  e.target.value,
                                  idx
                                )
                              }
                            />
                          </td>
                          <td>
                            <Select
                                // isMulti
                                options={Roles}
                                name='Roles'
                                onChange={this.changeRoleValue.bind(null, idx)}
                                placeholder='Select Roles...'
                                value={user["Role_List"][0]}/>
                          </td>
                          <td>
                            <Select
                                isMulti
                                options={Institutions}
                                name='Institutions'
                                onChange={this.changeInstitutionValue.bind(null, idx)}
                                placeholder='Select institutions...'
                                value={user["Institution_List"]}/>
                          </td>
                          <td>
                            <Tooltip title="Save" id={`save-${user.User_ID}`}>
                              <span
                                className="badge badge-cyan"
                                onClick={() => this.handleSave(idx)}
                              >
                                <Icon.Save size={20} />
                              </span>
                            </Tooltip>
                            &nbsp;&nbsp;
                            <Tooltip
                              title="Cancel"
                              id={`cancel-${user.User_ID}`}
                            >
                              <span
                                className="badge badge-orange"
                                onClick={() => this.restoreUser()}
                              >
                                <Icon.X size={15} />
                              </span>
                            </Tooltip>
                          </td>
                        </tr>
                      );
                    } else {
                      return (
                        <tr key={user.User_ID}>
                          <td>{user.User_ID}</td>
                          <td>{user.First_Name}</td>
                          <td>{user.Last_Name}</td>
                          <td>{user.Username}</td>
                          <td>{user.Email}</td>
                          <td>
                            <Select
                              // isMulti
                              isDisabled={true}
                              options={Roles}
                              name='Roles'
                              onChange={this.changeRoleValue.bind(null, idx)}
                              placeholder='Select Roles...'
                              value={user["Role_List"][0]}
                            />
                          </td>
                          <td>
                            <Select
                                isMulti
                                isDisabled={true}
                                options={Institutions}
                                name='Institutions'
                                onChange={this.changeInstitutionValue.bind(null, idx)}
                                placeholder='No Institutions Selected'
                                value={user["Institution_List"]}/>
                          </td>
                          <td>
                            <Tooltip title="Edit" id={`edit-${user.User_ID}`}>
                              <span
                                className="badge badge-cyan"
                                onClick={() => this.enableEdit(idx)}
                              >
                                <Icon.Edit size={20} />
                              </span>
                            </Tooltip>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Tooltip
                              title="Delete"
                              id={`delete-${user.User_ID}`}
                            >
                              <span
                                className="badge badge-danger"
                                onClick={() => this.handleRemove(user.User_ID)}
                              >
                                <Icon.Trash2 size={15} />
                              </span>
                            </Tooltip>
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default Users;
